export const tr = {
    'failed-to-load-banners-for-popup': "Banner'lar yüklenemedi. Tekrar deneyin."
};
